import useRoutes from "../../hooks/useRoutes";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../providers/AuthProvider";
import { usePortal } from "../../../Providers/PortalProvider";
import I18n from "../../../i18n";
import { generatePath } from "react-router";
import { Link } from "react-router-dom";
const getTitle = (title, userLang, portalLang) => {
    if (typeof title == "string") {
        return title;
    }
    if (title[userLang]) {
        return title[userLang];
    }
    if (title[portalLang]) {
        return title[portalLang];
    }
    return "";
};
const getLinkComponent = (item, routes) => {
    var _a, _b;
    if (item.type == "internal") {
        if (!item.data) {
            item.data = {};
        }
        if (item.target == "products.cards" ||
            item.target == "products.cards.category") {
            item.data.type = "cards";
        }
        else if (item.target == "products.calendars" ||
            item.target == "products.calendars.pages") {
            item.data.type = "calendars";
        }
        else if (item.target == "products.photogifts" ||
            item.target == "products.photogifts.category") {
            item.data.type = "photogifts";
        }
        return {
            component: Link,
            to: generatePath(routes[item.target].path, item.data),
        };
    }
    else if (item.type === "modal") {
        return {
        // We can display default menu redering
        };
    }
    else if (item.type === "cookiesettings") {
        return {
            component: Link,
            to: (_b = (_a = routes.cookiesdescription) === null || _a === void 0 ? void 0 : _a.path) !== null && _b !== void 0 ? _b : routes.frontpage.path,
        };
    }
    else {
        return {
            component: "a",
            href: item.target,
        };
    }
};
export const useMenu = () => {
    const routes = useRoutes();
    const { isAuthenticated } = useAuth();
    const { t } = useTranslation();
    const portal = usePortal();
    // Cache the routes? Because of translations we don't want to reload them all the time?
    const items = useMemo(() => {
        var _a, _b, _c, _d;
        const menu = ((_a = window.PAGE_SETTINGS.menu) !== null && _a !== void 0 ? _a : [])
            .filter((item) => {
            // If desktop, ignore
            if (item.device === 2) {
                return false;
            }
            if (item.visibility == 0) {
                return true;
            }
            if (item.visibility == 2 && isAuthenticated == false) {
                return true;
            }
            if (item.visibility == 1 && isAuthenticated == true) {
                return true;
            }
            return false;
        })
            .map((item) => {
            return Object.assign(Object.assign({}, item), { link: getLinkComponent(item, routes), title: getTitle(item.title, I18n.language.replace("-", "_"), portal.locale.default_language.replace("-", "_")), children: item.children.map((childItem) => {
                    return Object.assign(Object.assign({}, childItem), { title: getTitle(childItem.title, I18n.language.replace("-", "_"), portal.locale.default_language.replace("-", "_")), link: getLinkComponent(childItem, routes), children: childItem.children
                            ? childItem.children.map((grandChild) => (Object.assign(Object.assign({}, grandChild), { title: getTitle(grandChild.title, I18n.language.replace("-", "_"), portal.locale.default_language.replace("-", "_")) })))
                            : [] });
                }) });
        });
        menu.push({
            id: "spacer-1",
            type: "spacer",
        });
        menu.push({
            title: t("Contact us"),
            icon: "contact_mail",
            link: {
                component: Link,
                to: routes.contactus.path,
            },
        });
        if (portal.terms.termsOfService ||
            portal.terms.termsOfPurchase ||
            portal.webshop.hasPrivacyPolicy) {
            const terms = {
                title: t("Terms & policies"),
                icon: "security",
                type: "parent-without-link",
                children: [],
            };
            menu.push(terms);
            if (portal.terms.termsOfService &&
                portal.terms.termsOfService !== "N/A") {
                terms.children.push({
                    id: "terms-of-service",
                    title: t("Terms of service"),
                    icon: "security",
                    link: {
                        component: Link,
                        to: (_b = routes.termsofservice) === null || _b === void 0 ? void 0 : _b.path,
                    },
                });
            }
            if (portal.webshop.hasPrivacyPolicy) {
                terms.children.push({
                    id: "privacy-policy",
                    title: t("Privacy policy"),
                    icon: "security",
                    link: {
                        component: Link,
                        to: (_c = routes.privacypolicy) === null || _c === void 0 ? void 0 : _c.path,
                    },
                });
            }
            if (portal.terms.termsOfPurchase &&
                portal.terms.termsOfPurchase !== "N/A") {
                terms.children.push({
                    id: "terms-of-purchase",
                    title: t("Terms of purchase"),
                    icon: "security",
                    link: {
                        component: Link,
                        to: (_d = routes.termsofpurchase) === null || _d === void 0 ? void 0 : _d.path,
                    },
                });
            }
        }
        if (portal.webshop.chatbotMenuEnabled) {
            menu.push({
                title: t("Chat with us"),
                icon: "chat",
                type: "openchatbot",
            });
        }
        menu.push({
            title: t("Desktop version"),
            icon: "computer",
            show: 0,
            link: {
                href: "/sections/prophoto/packages.php?desktop",
                component: "a",
            },
        });
        const menuWithId = menu.map((item) => {
            var _a;
            return Object.assign(Object.assign({}, item), { id: (_a = item.id) !== null && _a !== void 0 ? _a : (typeof item.title === "string" ? item.title : "") });
        });
        return menuWithId;
    }, [
        t,
        routes,
        portal.terms.termsOfService,
        portal.terms.termsOfPurchase,
        portal.webshop.hasPrivacyPolicy,
        portal.webshop.chatbotMenuEnabled,
        portal.locale.default_language,
        isAuthenticated,
    ]);
    return items;
};
